import { render, staticRenderFns } from "./JobPreviewDescription.vue?vue&type=template&id=c6fb57d2&scoped=true"
import script from "./JobPreviewDescription.vue?vue&type=script&lang=js"
export * from "./JobPreviewDescription.vue?vue&type=script&lang=js"
import style0 from "./JobPreviewDescription.vue?vue&type=style&index=0&id=c6fb57d2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6fb57d2",
  null
  
)

export default component.exports